<template>
  <div class="flex flex-col gap-2 p-2">
    <div class="flex w-full items-center gap-2 p-2">
      <AppIcon
        name="regular-magnifying-glass"
        size="sm"
      />
      <input-text
        v-model="search_query"
        :placeholder="$t('navbar.topnavbar.selectTeam')"
        size="small"
      />
    </div>
    <div
      v-for="tenant in tenants_filtered"
      :key="`${tenant.id}-${tenant.type}`"
      class="hover:bg-gray-200"
    >
      <a :href="urlTenant(tenant)">
        <div
          :class="{ 'bg-gray-100': subdomain === tenant.attributes.subdomain }"
          class="flex cursor-pointer gap-2 p-2"
        >
          <figure
            class="image is-16x16"
            style="margin-top: 0.25rem"
          >
            <img
              :src="tenant.attributes.picture_favicon_url"
              alt="favicon-engage"
            />
          </figure>
          <div class="media-content font-medium">
            {{ tenant.attributes.name }}
          </div>
          <AppText
            v-if="isProfilePaused(profileOf(tenant))"
            variant="caption"
            as="span"
            class="ml-auto"
            >{{ $t('tenant.paused.noAccess') }}</AppText
          >
        </div>
      </a>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';
import { mapGetters } from '@/store/lib/vue3helpers.js';
import { PROFILE_TYPES } from '@/app/data/model_constants';
import { PROFILE_TO_ROUTES } from '@/app/data/route_constants';
import { zigguProfileTenantURL } from '@/app/util/urls';
import useTenantProfile, { isProfilePaused } from '@/app/composables/useTenantProfile';
import AppText from '@/app/shared_components/AppText.vue';
const { current_is_impersonation, current_user_tenants } = mapGetters([
  'current_is_impersonation',
  'current_user_tenants',
]);
const { profileOf } = useTenantProfile();

const route = useRoute();

const search_query = ref('');

const subdomain = computed(() => {
  if (PROFILE_TO_ROUTES[PROFILE_TYPES.SUPERVISOR].includes(route.name)) return PROFILE_TYPES.SUPERVISOR.toLowerCase();
  return route.params.subdomain;
});

const tenants_filtered = computed(() => {
  if (!current_user_tenants.value) {
    return [];
  }
  return _.filter(current_user_tenants.value, (tenant) =>
    tenant.attributes.name.toLowerCase().includes(search_query.value.toLowerCase()),
  );
});

function urlTenant(tenant) {
  const profile = profileOf(tenant);
  const url = zigguProfileTenantURL(profile, tenant);
  // append meta query params on impersonation for non-supervisor profiles
  if (current_is_impersonation.value && tenant.attributes.subdomain !== 'supervisor') {
    return `${url}?_profile_type=${profile.type}&_profile_id=${profile.id}`;
  }
  return url;
}
</script>
